import { ElementSlider } from '../elements/element-slider'
import { breakpointUp } from '../utils/breakpoints'

let eventSlider = null
let sliderClass = '.element-slider'

function initOurEvents() {

  if(!$(sliderClass).length) return false

  if(breakpointUp('xl')) {
    if(eventSlider) eventSlider.destroy()
  } else {
    eventSlider = new ElementSlider(sliderClass)
  }

}

initOurEvents()

export { initOurEvents }
